import React, { useEffect, useState } from "react";
import "./index.css";
import GraySearchIcon from "Assets/Icons/GraySearchIcon";

interface FilterItem {
  label: string;
  key: number;
  value: number;
}

interface FilterSearchListingProps {
  data: FilterItem[];
  selectedItem?: any;
  filterheadingListing: any;
  setfilterheadingListing: any;
  addDocumentTypeHandler?: any;
}

const FilterSearchListing: React.FC<FilterSearchListingProps> = ({
  data,
  selectedItem,
  filterheadingListing,
  setfilterheadingListing,
  addDocumentTypeHandler,
}) => {
  const [searchInput, setSearchInput] = useState<string>("");
  const [inputText, setInputText] = useState<string>("");
  const arr: FilterItem[] = data;

  useEffect(() => {
    setSearchInput("");
    if (selectedItem?.type === "input") {
      setInputText(selectedItem?.filterSelectedData || "");
    } else {
      setInputText("");
    }
  }, [selectedItem]);
  const handleCheckboxChange = (e: any, element: any) => {
    const { key } = element;

    // Find the item in filterheadingListing based on name
    const matchingItem = filterheadingListing.find(
      (ele: any) => ele.name === selectedItem.name
    );
    if (!matchingItem) {
      return;
    }
    if (key == "all") {
      if (e.target.checked) {
        setfilterheadingListing((prev: any) =>
          prev.map((item: any) =>
            item.name === matchingItem.name
              ? {
                  ...item,
                  filterSelectedData: [...matchingItem.data, element],
                }
              : item
          )
        );
      } else {
        setfilterheadingListing((prev: any) =>
          prev.map((item: any) =>
            item.name === matchingItem.name
              ? {
                  ...item,
                  filterSelectedData: [],
                }
              : item
          )
        );
      }
      return;
    }
    if (selectedItem.singleSelect) {
      if (e.target.checked) {
        setfilterheadingListing((prev: any) =>
          prev.map((item: any) =>
            item.name === matchingItem.name
              ? {
                  ...item,
                  filterSelectedData: [element],
                }
              : item
          )
        );
      } else {
        setfilterheadingListing((prev: any) =>
          prev.map((item: any) =>
            item.name === matchingItem.name
              ? {
                  ...item,
                  filterSelectedData: [],
                }
              : item
          )
        );
      }
      return;
    }
    // Multi select - same behavior as desktop react-select
    const isAlreadySelected = selectedItem.filterSelectedData?.some(
      (item: any) => item.value === element.value
    );
    if (isAlreadySelected) {
      setfilterheadingListing((prev: any) =>
        prev.map((item: any) =>
          item.name === matchingItem.name
            ? {
                ...item,
                filterSelectedData: item.filterSelectedData.filter(
                  (el: any) => el.value !== element.value && el.key !== "all"
                ),
              }
            : item
        )
      );
    } else {
      setfilterheadingListing((prev: any) =>
        prev.map((item: any) =>
          item.name === matchingItem.name
            ? {
                ...item,
                filterSelectedData: [
                  ...item.filterSelectedData.filter(
                    (el: any) => el.key !== "all"
                  ),
                  element,
                ],
              }
            : item
        )
      );
    }
  };

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchInput(event.target.value);
  };

  // Function to filter data based on the search input
  const filteredData = arr.filter((item) =>
    String(item.label).toLowerCase().includes(searchInput.toLowerCase())
  );
  const handleInputTextHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setInputText(value);
    setfilterheadingListing((prev: any) =>
      prev.map((item: any) =>
        item.name === selectedItem.name
          ? {
              ...item,
              filterSelectedData: value,
            }
          : item
      )
    );
  };
  return (
    <div className="w-100">
      {selectedItem.type ? (
        <div className="p-2">
          <input
            className="searchFilterInputTitle"
            type="text"
            placeholder={selectedItem.name}
            value={inputText}
            onChange={handleInputTextHandler}
          />
        </div>
      ) : (
        <div className="searchInputContainer">
          <GraySearchIcon className="searchIcon" />
          <input
            className="searchFilterInput"
            type="text"
            placeholder="Search..."
            value={searchInput}
            onChange={handleSearchInputChange}
          />
        </div>
      )}
      <div className="allChecboxDiv">
        {addDocumentTypeHandler && selectedItem.name === "Document Type" && (
          <div className="addNewDocDiv" onClick={addDocumentTypeHandler}>
            + Add New Document Type
          </div>
        )}
        {filteredData.map((item) => (
          <div key={item.key} className="checkboxDiv">
            <input
              className="form-check-input filterCheckbox"
              type="checkbox"
              onChange={(e) => handleCheckboxChange(e, item)}
              checked={
                selectedItem.filterSelectedData?.some(
                  (ele: any) => ele.value === item.value
                ) ?? false
              }
            />
            <span className="filterCheckboxSpan">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterSearchListing;
